import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";

import useFetch from "../useFetch";

import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import { AddCaseProps } from "src/pages/addCase/types";
import { PracticeDropdownResponse } from "src/components/caseStepTwo/types";
import { CaseSubmitResponse } from "./types";



const useCaseSubmit = (practiceDropdownApiRes?: PracticeDropdownResponse) => {
  const { showToast } = useContext(ToastContext)
  const navigate = useNavigate()



  const { loading: addCaseLoading, data: addCaseData, mutate: addNewCase } =
    useFetch<CaseSubmitResponse>(APIEndpoints.ADD_NEW_CASE);

  useEffect(() => {
    if (addCaseData && addCaseData.status === 200) {
      localStorage.removeItem('newCase');
      showToast([`Your request submitted successfully!`], ToastTypes.SUCCESS);
      const { redirect, case_id, precert_id } = addCaseData
      if (redirect.includes("precert_edit"))
        navigate(`/cases/${case_id}/precerts/${precert_id}/edit`)
      else 
        navigate(`/cases`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCaseData]);

  /** @fourth */
  const caseDataSubmission = (values: AddCaseProps) => {
    const prescription_attributes_attributes = [];
    if (values.prescription_attributes.scheduled_date_of_service) {
      prescription_attributes_attributes.push({
        name: "scheduled_date_of_service",
        value: values.prescription_attributes.scheduled_date_of_service
      });
    }
    if (values.prescription_attributes.injection_site) {
      prescription_attributes_attributes.push({
        name: "injection_site",
        value: values.prescription_attributes.injection_site
      });
    }

    const { scheduled_date_of_service, injection_site, ...actualPrescription } = values.prescription_attributes;

    const trimmed_shipments_attributes = [];
    if (values.case_attributes.ship_to) {
      if (values.case_attributes.ship_to === "other" && values.shipments_attributes && values.shipments_attributes.length > 0) {
        trimmed_shipments_attributes.push({
          ship_to: "other",
          ...values.shipments_attributes[0],
        });
      } else if (values.case_attributes.ship_to === "provider") {
        const practiceData = practiceDropdownApiRes && practiceDropdownApiRes.data && practiceDropdownApiRes.data.length > 0 &&
          practiceDropdownApiRes.data.find((prac) => prac.id === values.doctor_attributes.practice_id)

        if (practiceData)
          trimmed_shipments_attributes.push({
            ship_to: values.case_attributes.ship_to,
            ship_to_street: practiceData.address.street,
            ship_to_suite: practiceData.address.suite || "",
            ship_to_city: practiceData.address.city,
            ship_to_state: practiceData.address.state,
            ship_to_zip: practiceData.address.zip,
          })
      } else if (values.case_attributes.ship_to === "patient") {
        trimmed_shipments_attributes.push({
          ship_to: values.case_attributes.ship_to,
          ship_to_street: values.patient_attributes.address.street,
          ship_to_suite: values.patient_attributes.address.suite || "",
          ship_to_city: values.patient_attributes.address.city,
          ship_to_state: values.patient_attributes.address.state,
          ship_to_zip: values.patient_attributes.address.zip,
        })
      }
    }

    const { shipments_attributes, ...trimmedValues } = values;

    const newValues = {
      ...trimmedValues,
      drug_name: values.prescription_attributes.drug_name,
      ...(values.procedure_attributes ? {procedures_attributes: [
        { cpt_code: values.procedure_attributes.cpt_code },
      ]} : {}),
      prescription_attributes: {
        ...actualPrescription,
        written_date: values.prescription_attributes.written_date ? format(parse(values.prescription_attributes.written_date, "MM/dd/yyyy", new Date()),"dd/MM/yyyy") : format(new Date(),'dd/MM/yyyy') ,
        diagnosis_code: values.prescription_attributes.diagnosis_code.join(","),
        prescription_attributes_attributes,
      },
      ...(
        values.category !== "medrx" ? {
          status_name: values.category === "med" ? "Pending Med Benefit" : "Pending Rx Benefit" 
        } : {}
      ),
      ...(trimmed_shipments_attributes.length > 0 ? { shipments_attributes: trimmed_shipments_attributes } : {}),
      patient_firstlastname: `${values.patient_attributes.firstname} ${values.patient_attributes.lastname}`,
      patient_fullname: `${values.patient_attributes.firstname} ${values.patient_attributes.middlename} ${values.patient_attributes.lastname}`,
      patient_dob: values.patient_attributes.dob,
      insurances_attributes: values.insurances_attributes?.map((insurance, index) => {
        insurance.insurance_priority = index;
        return insurance;
      }),
      case_attributes_attributes: [{
        name: "soc",
        value: values.case_attributes.ship_to
      }],
      patient_attributes: {
        ...values.patient_attributes,
        ...(values.patient_attributes.patient_email && {
          patient_email: {
            id: values.patient_attributes.patient_email_id,
            email: values.patient_attributes.patient_email
          }
        })
      },
    };

    const { case_attributes, procedure_attributes, ...actualCaseValues } = newValues;
    //console.log("Case Submission.....",actualCaseValues)
    addNewCase({ case: actualCaseValues });
  };



  return { addCaseLoading, caseDataSubmission }
}

export default useCaseSubmit
